import { render } from "./DataInventoryAnalysisComposition.vue?vue&type=template&id=9aa415b0"
import script from "./DataInventoryAnalysisComposition.vue?vue&type=script&lang=js"
export * from "./DataInventoryAnalysisComposition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__